import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Link } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import moment from 'moment';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment/build/index';
import Select from 'react-select';

import Api from '../../../../libraries/api';
import AuthHelper from '../../../../libraries/auth-helper';
import Button from '@material-ui/core/Button';
import ErrorHandling from '../../../../libraries/error-handling';
import { toast, ToastContainer } from 'react-toastify';
import { history } from '../../../../shared/configure-store';
import { LEAVE_TYPES, LEAVE_STATUSES, HR_OVERVIEW_ROLES } from './constants';

require('dotenv').config();
const validator = new SimpleReactValidator({ locale: process.env.REACT_APP_LOCALE });

class UserLeavesEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loadingButton: false,
            errors: {},
            enableOverview: true,
            canUpdateStatus: false,
            users: [],
            id: '',
            user_id: null,
            leave_type: '',
            start_date: null,
            end_date: null,
            status: '',
            originalStatus: '',
            leaveTypes: LEAVE_TYPES,
            leaveStatuses: LEAVE_STATUSES,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        document.title = 'Abadi - Edit Leave';

        const id = this.props.match.params.id;
        this.__initProfile();

        Api.get('/user-leaves/' + id).then(resp => {
            if (resp?.data) {
                const data = resp.data;
                const userId = data.user_id || data.user?.id;
                const userName = data.user_name || data.user?.name || '';

                this.setState({
                    id: data.id,
                    user_id: userId ? { value: userId, label: userName } : null,
                    leave_type: data.leave_type || '',
                    start_date: data.start_date ? moment(data.start_date) : null,
                    end_date: data.end_date ? moment(data.end_date) : null,
                    status: data.status || 'Pending',
                    originalStatus: data.status || 'Pending',
                    loading: false,
                    leaveTypes: resp?.meta?.custom?.leaveTypes || this.state.leaveTypes,
                    leaveStatuses: resp?.meta?.custom?.leaveStatuses || this.state.leaveStatuses,
                    canUpdateStatus: resp?.meta?.custom?.isUpdate ?? this.state.canUpdateStatus,
                });
            } else {
                this.setState({ loading: false });
            }
        }).catch(() => {
            this.setState({ loading: false });
            this.showMessage(false, 'Failed to load leave data');
        });

        Api.get('/user-leaves?limit=1&page=1').then(resp => {
            const custom = resp?.meta?.custom;
            if (custom) {
                this.setState({
                    leaveTypes: LEAVE_TYPES,
                    leaveStatuses: custom.leaveStatuses || LEAVE_STATUSES,
                    canUpdateStatus: custom.isUpdate ?? this.state.canUpdateStatus,
                });
            }
        });
    }

    __initProfile = () => {
        const profile = AuthHelper.getProfile();
        const enableOverview = true; // DEVNOTE: All user can access this page
        // const enableOverview = HR_OVERVIEW_ROLES.includes(profile?.role);

        this.setState({
            enableOverview,
        }, () => {
            if (enableOverview) {
                this.__fetchUsers();
            }
        });
    };

    __fetchUsers = () => {
        Api.get('/users?limit=0&orderBy=name&sortedBy=asc&is_active=1').then(resp => {
            if (resp?.data) {
                const users = resp.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                }));
                this.setState({ users });
            }
        });
    };

    handleChange(e, prop) {
        this.setState({ [prop]: e.target.value });
    }

    handleDate = (date, prop) => {
        this.setState({ [prop]: date });
    };

    handleUserChange = (selected) => {
        this.setState({ user_id: selected });
    };

    showMessage = (status, message) => {
        if (status) toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT });
        else toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        const id = this.props.match.params.id;
        if (!validator.allValid()) {
            this.setState({ errors: validator.getErrorMessages() });
            return false;
        }

        if (moment(this.state.end_date).diff(moment(this.state.start_date)) < 0) {
            this.showMessage(false, 'End date must be on or after start date');
            return false;
        }

        this.setState({ errors: {}, loadingButton: true });

        const params = {
            user_id: this.state.user_id?.value,
            leave_type: this.state.leave_type,
            start_date: moment(this.state.start_date).format('YYYY-MM-DD'),
            end_date: moment(this.state.end_date).format('YYYY-MM-DD'),
        };

        const statusChanged = this.state.canUpdateStatus && this.state.status !== this.state.originalStatus;

        Api.patch('/user-leaves/' + id, params, false).then(() => {
            if (statusChanged) {
                return Api.patch('/user-leaves/' + id + '/status', { status: this.state.status }, false);
            }
            return Promise.resolve();
        }).then(() => {
            this.setState({ loadingButton: false });
            history.push('/user-leaves');
            this.showMessage(true, 'Leave request updated');
        }).catch(err => {
            if (ErrorHandling.checkErrorTokenExpired(err)) {
            } else {
                this.setState({ errors: err.errors || {}, loadingButton: false });
                this.showMessage(false, 'Invalid format data');
            }
        });
    };

    handleGo = (link) => {
        history.push(link);
    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12 px-lg-5">
                    <h1 className="page-title">Edit Leave</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/user-leaves">User Leaves</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Edit</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 mt-3 px-lg-5">
                    <div className="table-wrapper">
                        {this.state.loading ? (
                            <div className="text-center py-5">
                                <i className="fa fa-spinner fa-spin fa-2x"> </i>
                            </div>
                        ) : (
                            <form name="edit" id="editLeave" className="row" noValidate>
                                {this.state.enableOverview && (
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <Select
                                                options={this.state.users}
                                                onChange={this.handleUserChange}
                                                value={this.state.user_id}
                                                isClearable
                                                isSearchable
                                                styles={{
                                                    menu: (baseStyles) => ({ ...baseStyles, zIndex: 3 }),
                                                }}
                                            />
                                            {validator.message('user_id', this.state.user_id?.value, 'required')}
                                            <div className="text-danger">{this.state.errors.user_id}</div>
                                        </div>
                                    </div>
                                )}
                                {!this.state.enableOverview && this.state.user_id && (
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <TextField
                                                variant="outlined"
                                                value={this.state.user_id.label}
                                                fullWidth
                                                disabled
                                            />
                                        </div>
                                    </div>
                                )}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Leave Type</label>
                                        <TextField
                                            variant="outlined"
                                            select
                                            id="leave_type"
                                            name="leave_type"
                                            label="Leave Type"
                                            onChange={(e) => this.handleChange(e, 'leave_type')}
                                            value={this.state.leave_type}
                                            fullWidth
                                        >
                                            {this.state.leaveTypes.map(option => (
                                                <MenuItem key={option} value={option}>
                                                    {option}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        {validator.message('leave_type', this.state.leave_type, 'required')}
                                        <div className="text-danger">{this.state.errors.leave_type}</div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Start Date</label>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <DatePicker
                                                label="Start Date"
                                                value={this.state.start_date}
                                                onChange={(date) => this.handleDate(date, 'start_date')}
                                                format="DD MMM YYYY"
                                                cancelLabel="BATAL"
                                                inputVariant="outlined"
                                                autoOk
                                            />
                                        </MuiPickersUtilsProvider>
                                        {validator.message('start_date', this.state.start_date, 'required')}
                                        <div className="text-danger">{this.state.errors.start_date}</div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>End Date</label>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <DatePicker
                                                label="End Date"
                                                value={this.state.end_date}
                                                onChange={(date) => this.handleDate(date, 'end_date')}
                                                format="DD MMM YYYY"
                                                cancelLabel="BATAL"
                                                inputVariant="outlined"
                                                autoOk
                                            />
                                        </MuiPickersUtilsProvider>
                                        {validator.message('end_date', this.state.end_date, 'required')}
                                        <div className="text-danger">{this.state.errors.end_date}</div>
                                    </div>
                                </div>
                                {this.state.canUpdateStatus && (
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Status</label>
                                            <TextField
                                                variant="outlined"
                                                select
                                                id="status"
                                                name="status"
                                                label="Status"
                                                onChange={(e) => this.handleChange(e, 'status')}
                                                value={this.state.status}
                                                fullWidth
                                            >
                                                {this.state.leaveStatuses.map(option => (
                                                    <MenuItem key={option} value={option}>
                                                        {option}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                            <div className="text-danger">{this.state.errors.status}</div>
                                        </div>
                                    </div>
                                )}
                                <div className="col-12 text-center">
                                    <Button
                                        variant="contained"
                                        className="mr-3"
                                        onClick={() => this.handleGo('/user-leaves')}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.handleSubmit}
                                        disabled={this.state.loadingButton && 'disabled'}
                                    >
                                        Submit{this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i>}
                                    </Button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
                <ToastContainer autoClose={3000} />
            </div>
        );
    }
}

export default UserLeavesEdit;
